import { useState } from "react";

// https://stackoverflow.com/a/69538420
export const useUniqueId = (): string => {
  const [id] = useState(() => `id-${Math.random().toString(16).slice(2)}`);
  return id;
};
